import React from 'react';
import { motion } from 'framer-motion';

/**
 * SlideIn Animation Component
 * Slides in content from specified direction
 */
const SlideIn = ({ 
  children, 
  delay = 0, 
  duration = 0.6, 
  direction = 'left',
  distance = 100,
  ...props 
}) => {
  const directions = {
    left: { x: -distance },
    right: { x: distance },
    up: { y: distance },
    down: { y: -distance },
  };

  const slideOffset = directions[direction] || { x: -distance };

  return (
    <motion.div
      initial={slideOffset}
      animate={{ x: 0, y: 0 }}
      transition={{ 
        duration, 
        delay,
        ease: [0.4, 0, 0.2, 1] // Material Design easing
      }}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default SlideIn;
